import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { motion } from 'framer-motion';
import { 
  Send, 
  Plus, 
  XCircle,
  X
} from 'lucide-react';

const CobrancaForm = ({ isOpen, onClose, onSuccess, setCurrentView, isInline = false }) => {
  const [sendingCobranca, setSendingCobranca] = useState(false);
  const [cobrancaForm, setCobrancaForm] = useState({
    nomePagador: '',
    cobrancaID: '',
    documentoPagador: '',
    valor: '',
    valorLiquido: '',
    descricao: '',
    emailPagador: '',
    transactionID: '',
    linkCobranca: '',
    statusCobranca: 0,
    vencimento: '',
    expiracao: '',
    expirada: false,
    cobradorDocumento: '',
    cobradorNome: '',
    vencimentoString: '',
    valorString: '',
    valorLiquidoString: '',
    linkBoleto: '',
    statusCobrancaTexto: 'Aguardando_Pagamento',
    geradoPor: '',
    observacaoInterna: '',
    totalParcelas: 1,
    parcela: 1,
    telefonePagador: '',
    amazonLink: '',
    uf: '',
    recorrenciaID: 0,
    formaDePagamento: '',
    pagamento: '',
    pagamentoString: '',
    descricao2: '',
    parceiroLink: 0,
    linkPagamentoID: '',
    boletoCobrancaID: '',
    gerarNfe: 'NÃO',
    parcelas: '1/1',
    valorJuros: 0,
    multa: 0,
    desconto: 0,
    dataDeDescontoString: '',
    dataLimiteDePagamentoString: '',
    valorTotal: '',
    dateLimiteDePagamento: '',
    dateDesconto: '',
    linkContrato: '',
    linkContratoAssinado: '',
    linkContratoAditivo: '',
    linkContratoAditivoAssinado: '',
    grupoOgms: '',
    id: '',
    codigoFalanteRadar: '',
    comissoesCobranca: [
      { nome: '', porcentagem: 0 },
      { nome: '', porcentagem: 0 },
      { nome: '', porcentagem: 0 }
    ],
    indicadorPersonalizadoParceiro: '',
    DDD: '',
    NumeroTelefone: '',
    Franqueado: '',
    AssistenteComercial: '',
    Advogado: '',
    FranqueadoPorcentagem: 0,
    AssistenteComercialPorcentagem: 0,
    AdvogadoPorcentagem: 0,
    TemEspelhamento: false,
    processado_em: '',
    comissionadoResponsavel: false,
    resumoDeVendas: ''
  });

  // API de destino (API de cobrança, não backend de autenticação)
  const API_BASE_URL = 'http://157.90.117.119';

  // Funções para envio de cobrança
  const handleFormChange = (field, value) => {
    setCobrancaForm(prev => {
      const newForm = {
        ...prev,
        [field]: value
      };
      
      // Gerar código falante radar automaticamente quando o ID da cobrança for alterado
      if (field === 'cobrancaID' && value) {
        const cobrancaId = parseInt(value);
        if (!isNaN(cobrancaId)) {
          newForm.codigoFalanteRadar = `PC-${cobrancaId}-1/1`;
        }
      }
      
      return newForm;
    });
  };

  const handleComissaoChange = (index, field, value) => {
    setCobrancaForm(prev => ({
      ...prev,
      comissoesCobranca: prev.comissoesCobranca.map((comissao, i) => 
        i === index ? { ...comissao, [field]: value } : comissao
      )
    }));
  };

  const addComissao = () => {
    setCobrancaForm(prev => ({
      ...prev,
      comissoesCobranca: [...prev.comissoesCobranca, { nome: '', porcentagem: 0 }]
    }));
  };

  const removeComissao = (index) => {
    setCobrancaForm(prev => ({
      ...prev,
      comissoesCobranca: prev.comissoesCobranca.filter((_, i) => i !== index)
    }));
  };

  const resetForm = () => {
    setCobrancaForm({
      nomePagador: '',
      cobrancaID: '',
      documentoPagador: '',
      valor: '',
      valorLiquido: '',
      descricao: '',
      emailPagador: '',
      transactionID: '',
      linkCobranca: '',
      statusCobranca: 0,
      vencimento: '',
      expiracao: '',
      expirada: false,
      cobradorDocumento: '',
      cobradorNome: '',
      vencimentoString: '',
      valorString: '',
      valorLiquidoString: '',
      linkBoleto: '',
      statusCobrancaTexto: 'Aguardando_Pagamento',
      geradoPor: '',
      observacaoInterna: '',
      totalParcelas: 1,
      parcela: 1,
      telefonePagador: '',
      amazonLink: '',
      uf: '',
      recorrenciaID: 0,
      formaDePagamento: '',
      pagamento: '',
      pagamentoString: '',
      descricao2: '',
      parceiroLink: 0,
      linkPagamentoID: '',
      boletoCobrancaID: '',
      gerarNfe: 'NÃO',
      parcelas: '1/1',
      valorJuros: 0,
      multa: 0,
      desconto: 0,
      dataDeDescontoString: '',
      dataLimiteDePagamentoString: '',
      valorTotal: '',
      dateLimiteDePagamento: '',
      dateDesconto: '',
      linkContrato: '',
      linkContratoAssinado: '',
      linkContratoAditivo: '',
      linkContratoAditivoAssinado: '',
      grupoOgms: '',
      id: '',
      codigoFalanteRadar: '',
      comissoesCobranca: [
        { nome: '', porcentagem: 0 },
        { nome: '', porcentagem: 0 },
        { nome: '', porcentagem: 0 }
      ],
      indicadorPersonalizadoParceiro: '',
      DDD: '',
      NumeroTelefone: '',
      Franqueado: '',
      AssistenteComercial: '',
      Advogado: '',
      FranqueadoPorcentagem: 0,
      AssistenteComercialPorcentagem: 0,
      AdvogadoPorcentagem: 0,
      TemEspelhamento: false,
      processado_em: '',
      comissionadoResponsavel: false,
      resumoDeVendas: ''
    });
  };

  const enviarCobranca = async () => {
    // Validação básica
    if (!cobrancaForm.nomePagador.trim()) {
      toast.error('Nome do pagador é obrigatório!');
      return;
    }
    
    setSendingCobranca(true);
    
    try {
      // Gerar ID automático se não fornecido
      let cobrancaId = parseInt(cobrancaForm.cobrancaID);
      if (!cobrancaId || isNaN(cobrancaId)) {
        // Gerar ID baseado no timestamp atual
        cobrancaId = Math.floor(Date.now() / 1000);
        console.log(`ID gerado automaticamente: ${cobrancaId}`);
      }
      
      // Preparar dados para envio
      const dadosParaEnvio = {
        ...cobrancaForm,
        valor: parseFloat(cobrancaForm.valor) || 0,
        valorLiquido: parseFloat(cobrancaForm.valorLiquido) || 0,
        valorTotal: parseFloat(cobrancaForm.valorTotal) || parseFloat(cobrancaForm.valor) || 0,
        cobrancaID: cobrancaId,
        id: cobrancaId,
        totalParcelas: parseInt(cobrancaForm.totalParcelas) || 1,
        parcela: parseInt(cobrancaForm.parcela) || 1,
        recorrenciaID: parseInt(cobrancaForm.recorrenciaID) || 0,
        valorJuros: parseFloat(cobrancaForm.valorJuros) || 0,
        multa: parseFloat(cobrancaForm.multa) || 0,
        desconto: parseFloat(cobrancaForm.desconto) || 0,
        parceiroLink: parseInt(cobrancaForm.parceiroLink) || 0,
        FranqueadoPorcentagem: parseFloat(cobrancaForm.FranqueadoPorcentagem) || 0,
        AssistenteComercialPorcentagem: parseFloat(cobrancaForm.AssistenteComercialPorcentagem) || 0,
        AdvogadoPorcentagem: parseFloat(cobrancaForm.AdvogadoPorcentagem) || 0,
        codigoFalanteRadar: `PC-${cobrancaId}-1/1`,
        comissoesCobranca: cobrancaForm.comissoesCobranca.map(comissao => ({
          ...comissao,
          porcentagem: parseFloat(comissao.porcentagem) || 0
        })).filter(comissao => comissao.nome.trim() !== ''),
        processado_em: new Date().toISOString()
      };

      // Fazer POST para a API
      const response = await axios.post(`${API_BASE_URL}/json`, dadosParaEnvio, {
        timeout: 30000,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });

      if (response.status === 200 || response.status === 201) {
        toast.success('Cobrança enviada com sucesso!');
        console.log('Resposta da API:', response.data);
        
        // Limpar formulário
        resetForm();
        
        // Notificar sucesso para o componente pai
        if (onSuccess) {
          onSuccess(response.data);
        }
        
        // Se for inline, redirecionar para consultas
        if (isInline && setCurrentView) {
          setCurrentView('search');
        }
        
        // Fechar modal se não for inline
        if (!isInline && onClose) {
          onClose();
        }
      }
    } catch (error) {
      console.error('Erro ao enviar cobrança:', error);
      toast.error(`Erro ao enviar cobrança: ${error.response?.data?.message || error.message}`);
    } finally {
      setSendingCobranca(false);
    }
  };

  // Se for modal e não estiver aberto, não renderizar
  if (!isInline && !isOpen) return null;

  // Conteúdo do formulário
  const formContent = (
    <div className="bg-white rounded-lg shadow-lg p-6">
      {/* Header */}
      <div className="mb-6">
        <div className="flex items-center space-x-3">
          <div className="p-2 bg-green-100 rounded-lg">
            <Send className="w-6 h-6 text-green-600" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Nova Cobrança</h2>
            <p className="text-sm text-gray-500">Preencha todos os campos para criar uma nova cobrança</p>
          </div>
        </div>
      </div>

      {/* Formulário */}
      <div className="space-y-6">
        {/* Informações Básicas */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nome do Pagador *
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={cobrancaForm.nomePagador}
              onChange={(e) => handleFormChange('nomePagador', e.target.value)}
              placeholder="Nome completo"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Documento do Pagador
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={cobrancaForm.documentoPagador}
              onChange={(e) => handleFormChange('documentoPagador', e.target.value)}
              placeholder="CPF/CNPJ"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email do Pagador
            </label>
            <input
              type="email"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={cobrancaForm.emailPagador}
              onChange={(e) => handleFormChange('emailPagador', e.target.value)}
              placeholder="email@exemplo.com"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Valor *
            </label>
            <input
              type="number"
              step="0.01"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={cobrancaForm.valor}
              onChange={(e) => handleFormChange('valor', e.target.value)}
              placeholder="0.00"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Valor Líquido
            </label>
            <input
              type="number"
              step="0.01"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={cobrancaForm.valorLiquido}
              onChange={(e) => handleFormChange('valorLiquido', e.target.value)}
              placeholder="0.00"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              ID da Cobrança
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={cobrancaForm.cobrancaID}
              onChange={(e) => handleFormChange('cobrancaID', e.target.value)}
              placeholder="Deixe vazio para gerar automaticamente"
            />
          </div>
        </div>

        {/* Cobrador */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Documento do Cobrador
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={cobrancaForm.cobradorDocumento}
              onChange={(e) => handleFormChange('cobradorDocumento', e.target.value)}
              placeholder="CNPJ do cobrador"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nome do Cobrador
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={cobrancaForm.cobradorNome}
              onChange={(e) => handleFormChange('cobradorNome', e.target.value)}
              placeholder="Nome da empresa cobradora"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Gerado Por
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={cobrancaForm.geradoPor}
              onChange={(e) => handleFormChange('geradoPor', e.target.value)}
              placeholder="Nome de quem gerou"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Grupo OGMS
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={cobrancaForm.grupoOgms}
              onChange={(e) => handleFormChange('grupoOgms', e.target.value)}
              placeholder="Nome do grupo"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Boleto Cobrança ID
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={cobrancaForm.boletoCobrancaID}
              onChange={(e) => handleFormChange('boletoCobrancaID', e.target.value)}
              placeholder="ID do boleto"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Comissionado Responsável
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={cobrancaForm.comissionadoResponsavel}
              onChange={(e) => handleFormChange('comissionadoResponsavel', e.target.value)}
              placeholder="Nome do comissionado responsável"
            />
          </div>
        </div>

        {/* Descrições */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Descrição
            </label>
            <textarea
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              rows="3"
              value={cobrancaForm.descricao}
              onChange={(e) => handleFormChange('descricao', e.target.value)}
              placeholder="Descrição da cobrança"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Descrição 2
            </label>
            <textarea
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              rows="3"
              value={cobrancaForm.descricao2}
              onChange={(e) => handleFormChange('descricao2', e.target.value)}
              placeholder="Descrição adicional"
            />
          </div>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Observação Interna
          </label>
          <textarea
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            rows="3"
            value={cobrancaForm.observacaoInterna}
            onChange={(e) => handleFormChange('observacaoInterna', e.target.value)}
            placeholder="Observações internas"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Resumo de Vendas
          </label>
          <textarea
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            rows="3"
            value={cobrancaForm.resumoDeVendas}
            onChange={(e) => handleFormChange('resumoDeVendas', e.target.value)}
            placeholder="Resumo das vendas"
          />
        </div>

        {/* Comissões */}
        <div className="mt-8">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-800">Comissões</h3>
            <button
              type="button"
              className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors text-sm"
              onClick={addComissao}
            >
              <Plus className="w-4 h-4 mr-1 inline" />
              Adicionar Comissão
            </button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {cobrancaForm.comissoesCobranca.map((comissao, index) => (
              <div key={index} className="border border-gray-200 rounded-lg p-4">
                <div className="flex items-center justify-between mb-3">
                  <h4 className="font-medium text-gray-800">Comissão {index + 1}</h4>
                  <button
                    type="button"
                    className="text-red-500 hover:text-red-700"
                    onClick={() => removeComissao(index)}
                  >
                    <XCircle className="w-4 h-4" />
                  </button>
                </div>
                
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Nome
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      value={comissao.nome}
                      onChange={(e) => handleComissaoChange(index, 'nome', e.target.value)}
                      placeholder="Nome do comissionado"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Porcentagem (%)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      value={comissao.porcentagem}
                      onChange={(e) => handleComissaoChange(index, 'porcentagem', e.target.value)}
                      placeholder="0.00"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Responsável
                    </label>
                    <select
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      value={comissao.comissionadoResponsavel ? 'true' : 'false'}
                      onChange={(e) => handleComissaoChange(index, 'comissionadoResponsavel', e.target.value === 'true')}
                    >
                      <option value="false">Não</option>
                      <option value="true">Sim</option>
                    </select>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Comissões Pré-definidas */}
          <div className="mt-6">
            <h4 className="text-md font-semibold text-gray-800 mb-3">Comissões Específicas</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="border border-gray-200 rounded-lg p-4">
                <h5 className="font-medium text-gray-800 mb-3">Franqueado</h5>
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Nome
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      value={cobrancaForm.Franqueado}
                      onChange={(e) => handleFormChange('Franqueado', e.target.value)}
                      placeholder="Nome do franqueado"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Porcentagem (%)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      value={cobrancaForm.FranqueadoPorcentagem}
                      onChange={(e) => handleFormChange('FranqueadoPorcentagem', e.target.value)}
                      placeholder="0.00"
                    />
                  </div>
                </div>
              </div>
              
              <div className="border border-gray-200 rounded-lg p-4">
                <h5 className="font-medium text-gray-800 mb-3">Assistente Comercial</h5>
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Nome
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      value={cobrancaForm.AssistenteComercial}
                      onChange={(e) => handleFormChange('AssistenteComercial', e.target.value)}
                      placeholder="Nome do assistente"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Porcentagem (%)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      value={cobrancaForm.AssistenteComercialPorcentagem}
                      onChange={(e) => handleFormChange('AssistenteComercialPorcentagem', e.target.value)}
                      placeholder="0.00"
                    />
                  </div>
                </div>
              </div>
              
              <div className="border border-gray-200 rounded-lg p-4">
                <h5 className="font-medium text-gray-800 mb-3">Advogado</h5>
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Nome
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      value={cobrancaForm.Advogado}
                      onChange={(e) => handleFormChange('Advogado', e.target.value)}
                      placeholder="Nome do advogado"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Porcentagem (%)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                      value={cobrancaForm.AdvogadoPorcentagem}
                      onChange={(e) => handleFormChange('AdvogadoPorcentagem', e.target.value)}
                      placeholder="0.00"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Informações Adicionais */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Telefone
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={cobrancaForm.telefonePagador}
              onChange={(e) => handleFormChange('telefonePagador', e.target.value)}
              placeholder="(11) 99999-9999"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              UF
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={cobrancaForm.uf}
              onChange={(e) => handleFormChange('uf', e.target.value)}
              placeholder="SP"
              maxLength="2"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Vencimento
            </label>
            <input
              type="date"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={cobrancaForm.vencimento}
              onChange={(e) => handleFormChange('vencimento', e.target.value)}
            />
          </div>
        </div>

        {/* Botões de Ação */}
        <div className="mt-8 flex justify-end space-x-3">
          {isInline && setCurrentView && (
            <button
              type="button"
              className="px-6 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors"
              onClick={() => setCurrentView('search')}
            >
              Cancelar
            </button>
          )}
          {!isInline && onClose && (
            <button
              type="button"
              className="px-6 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors"
              onClick={onClose}
            >
              Cancelar
            </button>
          )}
          <button
            type="button"
            className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors flex items-center space-x-2"
            onClick={enviarCobranca}
            disabled={sendingCobranca}
          >
            {sendingCobranca ? (
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <Send className="w-5 h-5" />
            )}
            <span>{sendingCobranca ? 'Enviando...' : 'Enviar Cobrança'}</span>
          </button>
        </div>
      </div>
    </div>
  );

  // Renderizar baseado no tipo (modal ou inline)
  if (isInline) {
    return formContent;
  }

  // Renderizar como modal
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className="bg-white rounded-lg shadow-xl max-w-6xl w-full max-h-[90vh] overflow-y-auto"
      >
        {formContent}
      </motion.div>
    </div>
  );
};

export default CobrancaForm;
